<label class="custom-checkbox" [ngClass]="{'checked': checkboxData.checked}">
    <input type="checkbox" [(ngModel)]="checkboxData.checked" (change)="onCheckboxChange()" class="hidden-checkbox">
    <span class="checkmark">&#10003;</span>
  </label>
  
